module.exports = __webpack_public_path__ + "img/Wayfair.41c7c6ce.png";